export const MAX_QUOTE_PHOTOS = 5;

export {
  PROJECT_IMAGE_MAX_UPLOAD_BYTES,
  projectImageOversizeMessage,
} from "./projectImageUploadLimits";
